import { AutogenModelRateIndexControl, AutogenRowRateIndexControl } from "./autogen/AutogenModelRateIndexControl";

export class ModelRateIndexControl extends AutogenModelRateIndexControl<RowRateIndexControl> {
	constructor() {
		super(RowRateIndexControl);
	}
}

export class RowRateIndexControl extends AutogenRowRateIndexControl {
}